import { render, staticRenderFns } from "./ClinicKpi.vue?vue&type=template&id=13b1dc4c"
import script from "./ClinicKpi.vue?vue&type=script&lang=js"
export * from "./ClinicKpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports